import React from 'react';
import { motion } from 'framer-motion';
import { Smiley, SmileySad } from '@phosphor-icons/react';
import type { Intent } from './options';
interface IntentToggleProps {
  value: Intent;
  onChange: (intent: Intent) => void;
}
const OPTIONS: {
  id: Intent;
  label: string;
  Icon: typeof Smiley;
}[] = [{
  id: 'compliment',
  label: 'Send a Compliment',
  Icon: Smiley
}, {
  id: 'complaint',
  label: 'File a Complaint',
  Icon: SmileySad
}];
export function IntentToggle({
  value,
  onChange
}: IntentToggleProps) {
  return <div role="tablist" aria-label="Choose contact intent" className="relative grid grid-cols-2 gap-1 rounded-[var(--radius)] bg-[hsl(var(--muted))] p-1" data-id="element-68">
      {OPTIONS.map(({
      id,
      label,
      Icon
    }) => {
      const active = value === id;
      return <button key={id} role="tab" type="button" aria-selected={active} onClick={() => onChange(id)} className="relative z-10 flex items-center justify-center gap-2 rounded-[calc(var(--radius)-0.25rem)] px-4 py-2.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2 focus-visible:ring-offset-[hsl(var(--muted))]" data-id="element-69">
            {active && <motion.span layoutId="intent-pill" transition={{
          type: 'spring',
          stiffness: 500,
          damping: 38
        }} className="absolute inset-0 -z-10 rounded-[calc(var(--radius)-0.25rem)] bg-[hsl(var(--background))] shadow-sm" data-id="element-70" />}
            <Icon size={18} weight={active ? 'fill' : 'regular'} className={active ? 'text-[hsl(var(--foreground))]' : 'text-[hsl(var(--muted-foreground))]'} data-id="element-71" />
            <span className={active ? 'text-[hsl(var(--foreground))]' : 'text-[hsl(var(--muted-foreground))]'} data-id="element-72">
              {label}
            </span>
          </button>;
    })}
    </div>;
}